import React, { useState, useEffect, useMemo } from "react";

import main_logo_blue_noBgc from "../../assets/images/main-logo-blue-noBgc.png";
import main_logo_grey_noBgc from "../../assets/images/main-logo-grey-noBgc.png";
import main_logo_navyBlue_noBgc from "../../assets/images/main-logo-navyBlue-noBgc.png";
import main_logo_grey2_noBgc from "../../assets/images/main-logo-grey2-noBgc.png";

function AboutCard() {
    const CardContent = [
        {
            title: "為什麼要使用配速計算機？",
            subTitle: "跟汽車一樣，定速是最省油的！＋自己的配速自己掌控",
            contentFirst: "長時間耐力運動中，穩定的輸出能夠讓體力耗損降到最低，避免前段過於興奮或是對於體力過度自信而導致前段失速後段屍速。在變因降低的情況下，對自己的生理狀態掌控、補給規劃也更能順暢地執行。",
            contentSecond:
                "當然有人會問說，那我是不是跟著配速員就好，這當然是一個方式，但是配速員通常是配大會時間、而我們的成績是看晶片成績，人數多的比賽兩者可能相差至二至五分鐘或更多，所以喵喵推薦的做法是，自己的配速自己算，而配速員則當作自己相對位置的評估方式。",
            img: `${main_logo_blue_noBgc}`,
        },
        {
            title: "跟其他配速計算機有什麼不同？",
            subTitle: "起跑人多、上下坡喵喵都幫你放進去～",
            contentFirst:
                "因為太害怕撞牆，從2018台北馬初半馬開始，每場喵喵跑過的馬拉松都會自己計算配速，其他的配速計算機多半是總時間／總里程，但初半馬後發現出發的人潮及地形影響配速非常大。如果前面被卡住，中段過於積極追回配速，其實更容易導致後段無力。",
            contentSecond: "於是，喵喵從2019年就開始以EXCEL的方式將台北馬與渣打馬的配速計算機分享給跑友，經歷多場賽事之後再加入各個朋友的回饋慢慢調整參數優化，2021年感謝友人協助得以實現網頁化，讓更多跑友能夠輕易計算配速並印製配速手環方便賽事使用。",
            contentThird:
                "今年重新調整參數並加入客製化水站進站計算，並且首度嘗試了網頁視覺呈現設計，也非常幸運能與同為日月潭環湖馬拉松配速員的前端工程師豪豪合作，無論是運動上或網頁製作都非常專業且細心！希望能讓跑友更能依照自己的狀況調配，創造佳績。",
            img: `${main_logo_navyBlue_noBgc}`,
        },
        {
            title: "如何使用喵喵牌配速計算機幫你達成佳績",
            subTitle: "算好配速、作好功課、印出配速手環",
            contentFirst: "輸入全馬或半馬的預計成績之後，會自動跑出該場賽事的配速，再以時間或里程安排補給停站，配速會跟著調整。也可依照自己日常練習輸入二到三個完賽時間，再依據自己靠近比賽日的體況決定最後目標。",
            contentSecond:
                "配速表計算完成後，可以搭配置放在同頁面的官方地圖、影片，能夠更加了解每個賽段會遭遇的路況，進而能夠執行意象訓練，在正式比賽中更有餘裕觀照體況。也可印出配速手環，這次經過討論後我們僅留下必須內容（畢竟認真比賽的時候沒啥精力同時讀取太多資訊），希望能夠更精確地協助各位跑友。",
            contentThird: "P.S. 憑配速手環或配速截圖分享到馬拉松博覽會找喵喵好友攤位，也會有一些優惠或小禮物可以拿唷！",
            img: `${main_logo_grey_noBgc}`,
        },
        {
            title: "會有其他賽事的配速計算機嗎？",
            subTitle: "想做，但需要乾爹乾媽加速器",
            contentFirst:
                "這完全是吃了誠實豆沙包後的答案（笑），留下的灰色頁籤都是未來想執行的方向，鄰近且有研究過參數的渣打馬配速計算機、以及其他人數較多的賽事；還有備賽資訊參考，像是如何完成初馬或初鐵或初越野、賽事小撇步、訓練概念與方向統整；喵喵有很多認識的越野賽事單位及運動相關廠商，也希望能夠不定期開設團報或團購等，服務廣大好友們。",
            contentSecond: "但小社畜如喵喵各種工作賽事奔來跑去，工程師豪豪除了工作運動訓練、百忙之中還硬是接下了這個專案（重點是不能壓縮他陪他家老婆大人的時間），所以懇請各位乾爹乾媽可以請我們喝珍奶加速各項功能開通，當然也歡迎許願與提供各種建議啦～",
            contentThird: "",
            img: `${main_logo_grey2_noBgc}`,
        },
    ];
    return (
        <>
            {CardContent.map((item, index) => (
                <div key={index} className="card-contain-wrap">
                    <h3>Q: {item.title}</h3>
                    <div className="d-flex align-items-center row">
                        <div className="col-lg-9 ">
                            <h4>A: {item.subTitle}</h4>
                            {item.contentFirst && <p>{item.contentFirst}</p>}
                            {item.contentSecond && <p>{item.contentSecond}</p>}
                            {item.contentThird && <p>{item.contentThird}</p>}
                        </div>
                        <div className="col-lg-3  about-icon-wrap">
                            <img src={item.img} alt={`「${item.title}」的icon`} />
                        </div>
                    </div>
                </div>
            ))}
        </>
    );
}

export default AboutCard;
